import { Flex } from "@chakra-ui/react";
import { FormattedMessage } from "react-intl";

import { AddIcon, RanaButton, RanaTable, TrashIcon } from "@nens/ranalib";

import { useIconSrc } from "@/hooks/use-icon-src";

import { getIsEditable } from "../../../store/selectors";
import { usePublicationStore } from "../../../store/store";

interface PropsWithSearch {
  hasSearchString: true;
  clearSearchString: () => void;
}

interface PropsWithoutSearch {
  hasSearchString: false;
  onAddFiles: () => void;
}

export function TableEmptyPublicationFiles(props: PropsWithSearch | PropsWithoutSearch) {
  // If the user is searching, then we show a message that there are no results, with the option
  // to clear the search string.

  // If the user is not searching, then we show a message that there are no files, with the option
  // to add files (if the publication is editable).

  const icon = useIconSrc("files");
  const isEditable = usePublicationStore(getIsEditable);

  if (props.hasSearchString) {
    const { clearSearchString } = props;
    return (
      <RanaTable.Empty icon={icon}>
        <FormattedMessage
          id="publication.files.empty_search"
          defaultMessage="No files found for the current search. Clear the search to see all files."
        />
        <Flex marginTop={4} marginLeft="4">
          <RanaButton variant="secondary" onClick={clearSearchString} leftIcon={<TrashIcon />}>
            <FormattedMessage id="publication.files.clear_search" defaultMessage="Clear search" />
          </RanaButton>
        </Flex>
      </RanaTable.Empty>
    );
  } else {
    const { onAddFiles } = props;
    return (
      <RanaTable.Empty icon={icon}>
        {isEditable ? (
          <Flex marginTop={4} marginLeft="4">
            <RanaButton variant="primary" onClick={onAddFiles} leftIcon={<AddIcon />}>
              <FormattedMessage id="publication.files.empty" defaultMessage="Click to add files" />
            </RanaButton>
          </Flex>
        ) : (
          <FormattedMessage
            id="publication.files.empty_no_edit"
            defaultMessage="No files added yet"
          />
        )}
      </RanaTable.Empty>
    );
  }
}
